// extracted by mini-css-extract-plugin
module.exports = {"tableRiwayat":"styles_tableRiwayat__aiwpr"};